export default __webpack_public_path__ + "media/sermorelinSeo.9c496b6b80e59ef7441f082ef2738f9c.webp";